{
  "Description": "LB : NNNNN, NNNN NNNN",
  "RedundantCharacters": " -",
  "ValidationRegex": "^[0-9]{4}(?:[0-9]{4})?$",
  "TestData": {
    "Valid": [
      "1234",
      "1234 1234",
      "12341234"
    ],
    "Invalid": [
      "123",
      "1234567",
      "123456789"
    ]
  }
}